import { API_ENDPOINTS } from "./endpoints";
import { requestJson } from "./httpClient";

export const searchComponents = async (query) => {
    return requestJson(API_ENDPOINTS.components.search, {
        method: "POST",
        body: { query }
    });
};

export const searchComponentRows = async (query) => {
    const data = await requestJson(API_ENDPOINTS.components.rowsSearch, {
        method: "POST",
        body: { query }
    });

    const normalizeFile = file => file ? {
        ...file,
        isActive: file.isActive ?? file.is_active,
        employeeId: file.employeeId ?? file.employee_id,
        employeeName: file.employeeName ?? file.employee_name
    } : null;

    const normalizeRow = (row, fileKey, snakeFileKey) => ({
        ...row,
        nameAi: row.nameAi ?? row.name_ai,
        nameWithoutBackspace: row.nameWithoutBackspace ?? row.name_with_outbackspase,
        rowNumber: row.rowNumber ?? row.row_number,
        cntInt: row.cntInt ?? row.cnt_int,
        changed: row.changed ?? row.is_changed ?? false,
        [fileKey]: normalizeFile(row[fileKey] ?? row[snakeFileKey])
    });

    const byFileDateDescending = fileKey => (a, b) => {
        const aTime = Date.parse(a[fileKey]?.created || "") || 0;
        const bTime = Date.parse(b[fileKey]?.created || "") || 0;
        return bTime - aTime;
    };

    return {
        orders: (Array.isArray(data?.orders) ? data.orders : [])
            .map(row => normalizeRow(row, "fileOrder", "file_order"))
            .sort(byFileDateDescending("fileOrder")),
        offers: (Array.isArray(data?.offers) ? data.offers : [])
            .map(row => normalizeRow(row, "fileOffer", "file_offer"))
            .sort(byFileDateDescending("fileOffer"))
    };
};

export const filterByComponents = async (list) => {
    return requestJson(API_ENDPOINTS.components.filter, {
        method: "POST",
        body: { list }
    });
};

export const getOffersByName = async (name) => {
    return requestJson(API_ENDPOINTS.components.filterByComponents, {
        method: "POST",
        body: { name }
    });
};

export const getOffersByComponentName = async (name) => {
    return requestJson(API_ENDPOINTS.components.offersByName, {
        method: "POST",
        body: { name }
    });
};

export const fetchComponentInfo = async (partNumber) => {
    const data = await requestJson(API_ENDPOINTS.components.componentInfo, {
        method: "POST",
        body: { part_number: partNumber }
    });

    return data?.component || null;
};

export const refreshComponent = async (partNumber) => {
    return requestJson(API_ENDPOINTS.components.refreshComponent, {
        method: "POST",
        body: { part_number: partNumber }
    });
};

// [[Catalog Prototype]]: ready-to-render article history, aggregated by the backend.
export const fetchArticleHistory = partNumber => requestJson(`/api/components/history?${new URLSearchParams({ partNumber })}`);
